import { createContext, useContext } from 'react';

export type Notification = {
  id: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
};

export type NotificationContextValue = {
  notifications: Notification[];
  pushNotification: (notification: Omit<Notification, 'id'>) => void;
  dismissNotification: (id: string) => void;
};

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined);

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return ctx;
}